import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { useAuth, formatApiErrorDetail } from '../context/AuthContext';
import { LOGIN } from '@/constants/testIds';

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(username.trim(), password);
      navigate(user.role === 'admin' ? '/admin' : '/');
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid={LOGIN.container} className="flex h-screen w-screen items-center justify-center bg-[#F8FAFC] px-6">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-8 shadow-sm"
      >
        <h1 className="mb-1 font-heading text-2xl font-semibold text-slate-900">登录</h1>
        <p className="mb-6 font-body text-sm text-slate-500">登录后创建会议、管理会议记录</p>

        <label className="mb-2 block font-body text-sm text-slate-500">用户名</label>
        <Input
          data-testid={LOGIN.usernameInput}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="用户名"
          className="mb-4 h-12 border-slate-200 bg-slate-50 text-slate-900 focus-visible:ring-[#3B82F6]"
        />

        <label className="mb-2 block font-body text-sm text-slate-500">密码</label>
        <Input
          data-testid={LOGIN.passwordInput}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="密码"
          className="mb-2 h-12 border-slate-200 bg-slate-50 text-slate-900 focus-visible:ring-[#3B82F6]"
        />

        {error && (
          <p data-testid={LOGIN.errorMessage} className="mb-2 font-body text-sm text-red-500">
            {error}
          </p>
        )}

        <Button
          type="submit"
          data-testid={LOGIN.submitButton}
          disabled={loading}
          className="mt-6 h-12 w-full rounded-full bg-[#3B82F6] font-body text-base font-medium text-white hover:bg-[#3B82F6]/90"
        >
          <LogIn className="mr-2 h-4 w-4" /> {loading ? '登录中…' : '登录'}
        </Button>
      </form>
    </div>
  );
}
